import { Button } from "../../../utils/Utils";
import { GameConstants } from "../../../GameConstants";
import { SoundButtonContainer } from "./SoundButtonContainer";
import { MusicButtonContainer } from "./MusicButtonContainer";
import { BoardScene } from "../BoardScene";
import { AudioManager } from "../../../AudioManager";

export class GUI extends Phaser.GameObjects.Container {

    private soundButton: SoundButtonContainer;
    private musicButton: MusicButtonContainer;

    private menuButton: Button;
    private giveUpButton: Button;
    
    constructor(scene: Phaser.Scene) {

        super(scene);

        let topBarLeft = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "top_bar_left");
        topBarLeft.setOrigin(0);
        this.add(topBarLeft);

        let topBarRight = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "top_bar_right");
        topBarRight.setOrigin(0);
        this.add(topBarRight);

        this.menuButton = new Button(this.scene, 90, 43, "texture_atlas_language", "btn_menu", "btn_menu_hover");
        this.menuButton.onUp(this.onClickMenu, this);
        this.menuButton.visible = false;
        this.add(this.menuButton);

        this.giveUpButton = new Button(this.scene, 230, 43, "texture_atlas_language", "btn_giveUp", "btn_giveUp_hover");
        this.giveUpButton.onUp(this.onClickGiveUp, this);
        this.giveUpButton.visible = false;
        this.add(this.giveUpButton);

        this.soundButton = new SoundButtonContainer(this.scene);
        this.soundButton.x = GameConstants.GAME_WIDTH - 110;
        this.soundButton.y = 43;
        this.add(this.soundButton);

        this.musicButton = new MusicButtonContainer(this.scene);
        this.musicButton.x = GameConstants.GAME_WIDTH - 40;
        this.musicButton.y = 43;
        this.add(this.musicButton);
    }

    public startGame(): void {

        this.menuButton.visible = true;
        this.giveUpButton.visible = true;
    }

    private onClickMenu(): void {

        AudioManager.playSound("click");
        
        BoardScene.currentInstance.showPauseLayer();
    }

    private onClickGiveUp(): void {

        AudioManager.playSound("click");
        
        BoardScene.currentInstance.showGiveUpLayer();
    }
}
